/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Permit } from '../../../accessibility/permits';

export const AUTH_API_URLS_PREFIX = '/authentication';

export interface InspectorLoginParams {
    username: string;
    password: string;
    rememberMe?: boolean;
}

export interface SimpleLoginFormData extends InspectorLoginParams {
    token?: string;
}

export interface MisLoginFormData {
    personalID: string;
    phoneNumber: string;
}

export interface MisUsesDto {
    taxNumber: string;
    name: string;
}

export interface MisLoginResponseData {
    verificationCode: string;
}

export interface LoginResponseData {
    uiType: UiType;
    roles: UserRole[];
    permits: Permit[];
    userId: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email?: string;
    phone?: string;
    companyTaxNumber?: string;
}

export interface MisAuthStatusResponseData {
    authenticationStatus: MisAuthStatus;
    users: MisUsesDto[];
    errorCode: MisAuthCodes;
}

export interface MisAuthError {
    code: MisAuthCodes;
}

export const MIS_AUTH_STATUSES = [
    'USER_AUTHENTICATED',
    'OUTSTANDING_TRANSACTION',
    'NOT_VALID',
    'EXPIRED_TRANSACTION',
    'USER_CANCEL',
    'SENDING_ERROR',
    'SIM_ERROR',
    'INTERNAL_ERROR',
    'UNKNOWN_PHONE_NUMBER_ERROR',
    'AUTH_CERT_IS_NOT_VALID_ERROR',
    'INVALID_PARAMS_ERROR',
    'NO_AUTH_CERT_ERROR',
    'NO_SIGN_CERT_ERROR',
    'SERVICE_OVERLOADED_ERROR',
    'SIGN_CERT_IS_NOT_VALID_ERROR',
    'PHONE_ABSENT',
] as const;
export type MisAuthStatus = (typeof MIS_AUTH_STATUSES)[number];

export const MIS_AUTH_CODES = [
    2018, 1000, 1106, 2013, 2020, 1002, 2021, 2004, 2031, 2046, 3023, 3022, 3024, 3011, 3010, 3025, 3020, 3012, 3008,
    3018, 3016, 3014, 3019, 3013, 3015, 3017, 3009, 3100, 3006, 3003, 3007, 3001, 3002, 3004, 3005, 40101, 40102,
] as const;

export type MisAuthCodes = (typeof MIS_AUTH_CODES)[number];

//TODO: remove, use permits instead
export enum UiType {
    Inspector = 'INSPECTOR',
    RegionInspector = 'REGIONAL_INSPECTOR',
    CentralInspector = 'CENTRAL_INSPECTOR',
    Operator = 'OPERATOR',
    Taxpayer = 'TAXPAYER',
}

//TODO: remove, use permits instead
export enum UserRole {
    Admin = 'ADMIN',
    Director = 'DIRECTOR',
    Expert = 'EXPERT',
    Auditor = 'AUDITOR',
    Operator = 'OPERATOR',
    Taxpayer = 'TAXPAYER',
    RegionInspector = 'REGIONAL_INSPECTOR',
    CentralInspector = 'CENTRAL_INSPECTOR',
}
